/*
 * "Passt dazu" im Warenkorb-Drawer und auf der Warenkorbseite.
 *
 * Die Karten rendert sections/cart-upsell.liquid (Empfehlungs-Endpoint von
 * Shopify, damit Preise, Texte und Sprache stimmen). Die Behaelter
 * [data-cart-upsell] sind liquid-ajax-cart-"static elements": sie bleiben beim
 * Neuzeichnen des Warenkorbs stehen, der Inhalt wird hier nachgeladen.
 *
 * Geladen wird nur, wenn es gebraucht wird: beim Oeffnen des Drawers, auf der
 * Warenkorbseite beim Seitenaufruf und nach jeder Warenkorb-Aenderung.
 */
(function () {
  if (window.__s4tCartUpsell) return;
  window.__s4tCartUpsell = true;

  var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  var cache = {};
  var lastKey = '';
  var pending = null;

  function currentCart() {
    return window.liquidAjaxCart && window.liquidAjaxCart.cart;
  }

  function cartKey(cart) {
    if (!cart || !cart.items || !cart.items.length) return '';
    return cart.items.map(function (i) { return i.variant_id + 'x' + i.quantity; }).join('-') + '|' + cart.total_price;
  }

  function fetchSection(productId, intent) {
    var url = root + 'recommendations/products?section_id=cart-upsell&limit=10&intent=' + intent + '&product_id=' + productId;
    return fetch(url, { credentials: 'same-origin' })
      .then(function (r) { return r.ok ? r.text() : ''; })
      .then(function (html) {
        if (!html) return null;
        var doc = new DOMParser().parseFromString(html, 'text/html');
        return doc.querySelector('.cart-upsell__inner');
      })
      .catch(function () { return null; });
  }

  function load(force) {
    var cart = currentCart();
    var boxes = document.querySelectorAll('[data-cart-upsell]');
    if (!boxes.length) return;
    var key = cartKey(cart);
    if (!key) { render(boxes, null); lastKey = ''; return; }
    if (!force && key === lastKey) return;
    lastKey = key;

    // Basis: der zuletzt hinzugefuegte Artikel (steht in Shopify oben)
    var productId = cart.items[0].product_id;
    if (cache[key]) { render(boxes, cache[key]); return; }
    if (pending) pending.cancelled = true;
    var job = { cancelled: false };
    pending = job;

    fetchSection(productId, 'complementary').then(function (inner) {
      if (inner && Number(inner.getAttribute('data-count')) > 0) return inner;
      return fetchSection(productId, 'related');
    }).then(function (inner) {
      if (job.cancelled) return;
      cache[key] = inner;
      render(document.querySelectorAll('[data-cart-upsell]'), inner);
    });
  }

  function render(boxes, inner) {
    boxes.forEach(function (box) {
      var count = inner ? Number(inner.getAttribute('data-count')) : 0;
      var remaining = inner ? Number(inner.getAttribute('data-remaining')) : 0;
      // Warenkorbseite: nur solange der kostenlose Versand noch nicht erreicht ist
      var show = count > 0 && (box.getAttribute('data-cart-upsell') !== 'page' || remaining > 0);
      box.innerHTML = show ? inner.innerHTML : '';
      box.hidden = !show;
    });
  }

  // Direkt hinzufuegen
  document.addEventListener('click', function (event) {
    var btn = event.target.closest && event.target.closest('[data-cart-upsell-add]');
    if (!btn || !window.liquidAjaxCart) return;
    event.preventDefault();
    if (btn.classList.contains('is-loading')) return;
    btn.classList.add('is-loading');
    var onPage = !!btn.closest('[data-cart-upsell="page"]');
    window.liquidAjaxCart.add(
      { items: [{ id: Number(btn.getAttribute('data-cart-upsell-add')), quantity: 1 }] },
      { info: { s4tUpsell: true, s4tNoDrawer: onPage } }
    );
  });

  document.addEventListener('liquid-ajax-cart:request-end', function () {
    document.querySelectorAll('.cart-upsell__add.is-loading').forEach(function (b) { b.classList.remove('is-loading'); });
    // Nur nachladen, wenn gerade ein Behaelter sichtbar ist (offener Drawer oder Warenkorbseite)
    setTimeout(function () {
      if (document.body.classList.contains('js-show-ajax-cart') || document.querySelector('[data-cart-upsell="page"]')) {
        load(false);
      } else {
        lastKey = '';
      }
    }, 0);
  });

  // Drawer geoeffnet -> laden
  new MutationObserver(function () {
    if (document.body.classList.contains('js-show-ajax-cart')) load(false);
  }).observe(document.body, { attributes: true, attributeFilter: ['class'] });

  function start() {
    if (document.querySelector('[data-cart-upsell="page"]')) load(true);
  }
  if (window.liquidAjaxCart && window.liquidAjaxCart.init) start();
  else document.addEventListener('liquid-ajax-cart:init', start);
})();
